import { LegislationEvent } from "../../../lib/models";
import { updateLegDocSummary, updateSubscribedLegDocSummary, updateIsSubscribedToProject, updateIsSubscribedToProject2, updateLegEvents, updateSubLegEvents } from "../../../lib/slices/legislationList";

export function updateLegislationSummary(legislationIndex: number, docIndex: number, summary: string) {
    return updateLegDocSummary({Id: legislationIndex, docIndex, Summary: summary});
}

export function updateSubscribedLegislationSummary(legislationIndex: number, docIndex: number, summary: string) {
    return updateSubscribedLegDocSummary({Id: legislationIndex, docIndex, Summary: summary});
}

export function updateLegislationSubscription(legislationId: number, IsSubscribed: boolean) {
    return updateIsSubscribedToProject({LegislationId: legislationId, IsSubscribed});
}

export function updateSubscribedLegislationSubscription(legislationId: number, IsSubscribed: boolean) {
    return updateIsSubscribedToProject2({LegislationId: legislationId, IsSubscribed});
}

export function updateLegislationEvents(legislationIndex: number, events: LegislationEvent[]) {
    return updateLegEvents({LegislationIndex: legislationIndex, Events: events});
}

export function updateSubscribedLegislationEvents(legislationIndex: number, events: LegislationEvent[]) {
    return updateSubLegEvents({LegislationIndex: legislationIndex, Events: events});
}
